var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React, { useImperativeHandle } from "react";
import styled from "styled-components";
var StyledScrollBox = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-height: ", ";\n  min-height: 100px;\n  overflow: auto;\n"], ["\n  max-height: ", ";\n  min-height: 100px;\n  overflow: auto;\n"])), function (props) {
  return props.maxHeight && props.maxHeight !== "auto" ? props.maxHeight : "500px";
});
var ScrollBox = React.forwardRef(function (props, ref) {
  var children = props.children,
    maxHeight = props.maxHeight;
  var scrollBoxRef = React.createRef();
  var scrollToBottom = function scrollToBottom() {
    if (scrollBoxRef === null || scrollBoxRef === void 0 ? void 0 : scrollBoxRef.current) {
      scrollBoxRef.current.scrollTop = scrollBoxRef.current.scrollHeight;
    }
  };
  var scrollToTop = function scrollToTop() {
    if (scrollBoxRef === null || scrollBoxRef === void 0 ? void 0 : scrollBoxRef.current) {
      scrollBoxRef.current.scrollTop = 0;
    }
  };
  useImperativeHandle(ref, function () {
    return {
      scrollToBottom: scrollToBottom,
      scrollToTop: scrollToTop
    };
  });
  return React.createElement(StyledScrollBox, {
    maxHeight: maxHeight,
    ref: scrollBoxRef
  }, children);
});
export default ScrollBox;
var templateObject_1;